import React, { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CartDrawer from "./CartDrawer";
import { ServiceRow } from "./ServicesSection";
import { Tag } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const OffersPage = () => {
  const [list, setList] = useState([]);
  useEffect(() => { window.scrollTo(0, 0); axios.get(`${API}/services`).then((r) => setList(r.data.filter((s) => s.on_offer && s.offer_value))).catch(() => {}); }, []);
  return (
    <>
      <Navbar />
      <main className="min-h-[60vh] max-w-7xl mx-auto px-4 md:px-6 lg:px-12 py-12 md:py-16">
        <p className="text-primary font-semibold tracking-wide uppercase text-sm flex items-center gap-2"><Tag className="w-4 h-4" /> Limited Time</p>
        <h1 className="font-display text-3xl md:text-4xl font-bold text-gray-900 mt-2">Services on Offer</h1>
        <div className="w-20 h-1 bg-accent rounded-full mt-4" />
        {list.length === 0 ? (
          <p className="text-gray-500 py-16 text-center">No offers running right now. Check back soon!</p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-8">
            {list.map((s) => <ServiceRow key={s.id} s={s} />)}
          </div>
        )}
      </main>
      <Footer />
      <CartDrawer />
    </>
  );
};

export default OffersPage;
